<template>
  <div>
    <VueImageBrowser
      :images="filtered_galery"
      :image-properties="photoFields"
      :save-url="$store.state.base_url+'/galery/upload.php'"
      :max-images-per-row="5"
      allow-photo-pane
      allow-copy
      allow-upload
      allow-delete
      :save-request-headers="{}"
      @saved="onSave"
      @deleted="onDelete"
      @searched="onSearch"
    >
    </VueImageBrowser>
  </div>
</template>

<script>
import VueImageBrowser from "@akashmitra/vue-image-browser";
import axios from "axios";
export default {
  components: {
    VueImageBrowser,
  },
  data() {
    return {
      list_photos: [],
      searchPhrase: "",
      photoFields: {
        id: "ID",
        name: "Nom",
        url: "Url",
      },
    };
  },
  computed: {
    filtered_galery() {
      if (!this.list_photos) {
        return [];
      }
      var filtered = this.list_photos;
      if (this.searchPhrase.length > 0) {
        filtered = filtered.filter((item) =>
          item.name.includes(this.searchPhrase)
        );
      }
      return filtered;
    },
  },
  methods: {
    onSearch(e) {
      this.searchPhrase = e;
    },
    onDelete(e) {
      var _this = this;
      axios
        .get(this.$store.state.base_url + "/galery/delete.php?id=" + e.id)
        .then(function () {
          _this.fetchGalery();
        });
    },
    onSave(e) {
      this.fetchGalery();
    },
    fetchGalery() {
      var _this = this;
      axios
        .get(this.$store.state.base_url + "/galery/get.php")
        .then(function (response) {
          _this.list_photos = response.data;
        });
    },
  },
  created() {
    this.fetchGalery();
  },
};
</script>

<style>
.bg-blue-600 {
  background-color: #f29200;
  font-weight: bold;
}

.text-blue-600 {
  background-color: #f29200;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

.bg-white {
  border-radius: 5px;
  overflow: hidden;
  font-weight: bold;
}
</style>